exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app[data-v-257bb9fd]{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;margin-top:60px}h1[data-v-257bb9fd],h2[data-v-257bb9fd]{font-weight:400}ul[data-v-257bb9fd]{list-style-type:none;padding:0}li[data-v-257bb9fd]{display:inline-block;margin:0 10px}a[data-v-257bb9fd]{color:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-257bb9fd&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 350
// module chunks = 0